import React from 'react';
import {
  Container,
  EventNameWrapper,
  MappingRules,
  MappingRulesContainer,
  RulesBuilderContainer,
} from '@src/emp-3.0/components/MappedEventDetail/styled';
import { ALL_APPLICABLE_MAPPED_EVENTS_TYPE } from '@src/emp-3.0/constants/dimensions';

const CustomDimensionRulesRender = ({ current }) => {
  const rules = current?.mapped_event_names;
  const attributeName = current?.attribute_name;

  return (
    <Container>
      <div>Mapping Rules</div>
      <RulesBuilderContainer style={{ gap: 0 }}>
        <EventNameWrapper>
          <span style={{ padding: '8px' }}>When</span>
          <span style={{ padding: '8px', fontWeight: 500 }}>Tag Key * :</span>
          <span style={{ padding: '8px 12px 8px 4px', color: 'rgba(0, 0, 0, 0.88)' }}>
            {attributeName}
          </span>
        </EventNameWrapper>
        <MappingRulesContainer>
          <MappingRules style={{ gap: 0 }}>
            <div style={{ width: '75px', padding: '0 8px' }}>Select</div>
            <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '4px' }}>
              {rules?.length > 0 ? (
                ''
              ) : (
                <span style={{ color: 'rgba(0, 0, 0, 0.88)' }}>
                  {ALL_APPLICABLE_MAPPED_EVENTS_TYPE}
                </span>
              )}
              {rules?.map((item, index) => {
                return (
                  <span
                    style={{ color: 'rgba(0, 0, 0, 0.88)', textAlign: 'left' }}
                    key={`customDimensionRules_${index}`}
                  >
                    {item}
                  </span>
                );
              })}
            </div>
          </MappingRules>
        </MappingRulesContainer>
      </RulesBuilderContainer>
    </Container>
  );
};

export default CustomDimensionRulesRender;
